import { render, staticRenderFns } from "./RechercheIngredients.vue?vue&type=template&id=2cadf673&scoped=true&"
import script from "./RechercheIngredients.vue?vue&type=script&lang=js&"
export * from "./RechercheIngredients.vue?vue&type=script&lang=js&"
import style0 from "./RechercheIngredients.vue?vue&type=style&index=0&id=2cadf673&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cadf673",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cadf673')) {
      api.createRecord('2cadf673', component.options)
    } else {
      api.reload('2cadf673', component.options)
    }
    module.hot.accept("./RechercheIngredients.vue?vue&type=template&id=2cadf673&scoped=true&", function () {
      api.rerender('2cadf673', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Recettes/RechercheIngredients.vue"
export default component.exports